import { ChangeEvent } from "react";

export interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  errorText?: string;
  icon?: React.ReactNode;
}

export const TextInput = ({
  id,
  name,
  label,
  onChange,
  required,
  errorText,
  value,
  className,
  ...restProps
}: TextInputProps) => {
  const error = Boolean(errorText);
  const color = error ? "failure" : "";

  return (
    <div className="mb-4">
      {label && (
        <div className="mb-2 block">
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white"
          >
            {label} {required ? <span className="text-red-500">*</span> : ""}
          </label>
        </div>
      )}
      <input
        id={name}
        value={value}
        onChange={onChange}
        color={color}
        className={`bg-border border text-gray-900 text-sm rounded-md block w-full p-2 outline-none focus:ring-0 focus:ring-offset-0 focus:ring-border focus:border-gray-300
              ${error ? "border-red-500" : "border-gray-300"}
                `}
        {...restProps}
      />
      {errorText && <p className="text-xs text-red-500 mt-1">{errorText}</p>}
    </div>
  );
};
